export default __webpack_public_path__ + "static/media/use_presenter_app.e2c2153d.png";